import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { setNewRelicAngularVersion } from './app/observability/new-relic-version';
import { alwaysShowModalMask } from './app/utils/nz-modal-always-mask';
import { renderOnlyActiveTab } from './app/utils/nz-tabs-render-active-only';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

setNewRelicAngularVersion();
renderOnlyActiveTab();
alwaysShowModalMask();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
